"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMALLEST = exports.REACT_APP_RPC = exports.REACT_APP_CHAIN_PREFIX = exports.REACT_APP_SOCKET_URL = void 0;
exports.REACT_APP_SOCKET_URL = "https://auth.loop.fans";
exports.REACT_APP_CHAIN_PREFIX = "juno";
exports.REACT_APP_RPC = "https://rpc-juno.itastakers.com";
exports.SMALLEST = 1000000;
